<td class="td-name" text-left>
  <div class="title-status">
    <div layout-horizontal layout-align-items-center text-weight-semi-bold>
      <rt-icon [name]="icon()" margin-right-small />
      <div>
        {{ title() }}
        @if (isNew()) {
          <rt-badge
            color="primary-gradient"
            [text]="'app.common.new' | translate"
            margin-left-small-x
          />
        }
        @if (notifyInfo()) {
          <span class="notify-info">{{
            'app.subscriptions.notify_every_morning' | translate
          }}</span>
        }
      </div>
    </div>
  </div>
</td>

@for (type of types(); track trackByType($index, type)) {
  <td
    rt-activity-subscriptions-table-item
    [type]="$any(type)"
    [eventsGroup]="eventsGroup()"
    [activitySubscriptions]="activitySubscriptions()"
    (changeEvents)="changeEvents.emit($event)"
  ></td>
}
